import { Text } from '@fluentui/react-components';
import { RouteLink } from 'components/core';
import CheckoutBox from 'components/core/CheckoutBox/CheckoutBox';
import { useCart } from 'contexts/CartContext/CartContext.hooks';
import { ShippingMethod } from 'contexts/CartContext/CartContext.types';
import LineCard from '../Cards/Line/LineCard';
import AccessoryCard from '../Cards/Accessory/AccessoryCard';
import { useReviewOrderStyles } from './ReviewOrder.styles';

const ReviewOrder = () => {
    const styles = useReviewOrderStyles();

    const { cart, updateCartStepIndex } = useCart();

    return (
        <div className={styles.root}>
            <CheckoutBox>
                <div className={styles.baseInfoGrid}>
                    <div className={styles.titleContainer}>
                        <Text size={500} weight='semibold'>
                            Personal Information
                        </Text>
                    </div>
                    <div className={styles.baseInfoContainer}>
                        <div>
                            <Text weight='semibold'>Name:&nbsp;</Text>
                            <Text>
                                {cart.customerInfo.firstName} {cart.customerInfo.lastName}
                            </Text>
                        </div>
                        <div>
                            <Text weight='semibold'>Email:&nbsp;</Text>
                            <Text>{cart.customerInfo.emailAddress}</Text>
                        </div>
                        <div>
                            <Text weight='semibold'>Mobile:&nbsp;</Text>
                            <Text>{cart.customerInfo.phoneNumber}</Text>
                        </div>
                    </div>
                    <div className={styles.serviceAddressContainer}>
                        <div>
                            <Text weight='semibold'>Service Address:</Text>
                        </div>
                        <div>
                            <Text>{cart.customerInfo.address.addressLine1}</Text>
                        </div>
                        <div>
                            <Text>{cart.customerInfo.address.addressLine2}</Text>
                        </div>
                        <div>
                            <Text>
                                {cart.customerInfo.address.city}, {cart.customerInfo.address.state}{' '}
                                {cart.customerInfo.address.zipcode}
                            </Text>
                        </div>
                    </div>
                    <div className={styles.billingAddressContainer}>
                        <div>
                            <Text weight='semibold'>Billing Address:</Text>
                        </div>
                        {cart.customerInfo.isDifferentBillingAddress &&
                        cart.customerInfo.billingAddress ? (
                            <>
                                <div>
                                    <Text>
                                        {cart.customerInfo.billingAddress.address.addressLine1}
                                    </Text>
                                </div>
                                <div>
                                    <Text>
                                        {cart.customerInfo.billingAddress.address.addressLine2}
                                    </Text>
                                </div>
                                <div>
                                    <Text>
                                        {cart.customerInfo.billingAddress.address.city},{' '}
                                        {cart.customerInfo.billingAddress.address.state}{' '}
                                        {cart.customerInfo.billingAddress.address.zipcode}
                                    </Text>
                                </div>
                            </>
                        ) : (
                            <>
                                <div>
                                    <Text>{cart.customerInfo.address.addressLine1}</Text>
                                </div>
                                <div>
                                    <Text>{cart.customerInfo.address.addressLine2}</Text>
                                </div>
                                <div>
                                    <Text>
                                        {cart.customerInfo.address.city},{' '}
                                        {cart.customerInfo.address.state}{' '}
                                        {cart.customerInfo.address.zipcode}
                                    </Text>
                                </div>
                            </>
                        )}
                    </div>
                    <div className={styles.baseInfoEditContainer}>
                        <RouteLink
                            className={styles.link}
                            text='Edit'
                            onClick={() => updateCartStepIndex(1)}
                        />
                    </div>
                </div>
            </CheckoutBox>

            <CheckoutBox>
                <div className={styles.shippingSection}>
                    <div className={styles.titleContainer}>
                        <Text size={500} weight='semibold'>
                            Shipping
                        </Text>
                    </div>

                    <div className={styles.serviceAddressContainer}>
                        <div>
                            <Text weight='semibold'>
                                {cart.shippingMethod.method === ShippingMethod.StorePickup
                                    ? 'Store Pickup - Overnight Shipping'
                                    : 'Post Office'}
                            </Text>
                        </div>
                        <div>
                            <Text>{cart.shippingMethod.address.addressLine1}</Text>
                        </div>
                        <div>
                            <Text>{cart.shippingMethod.address.addressLine2}</Text>
                        </div>
                        <div>
                            <Text>
                                {cart.shippingMethod.address.city},{' '}
                                {cart.shippingMethod.address.state}{' '}
                                {cart.shippingMethod.address.zipcode}
                            </Text>
                        </div>
                    </div>
                    <div className={styles.baseInfoEditContainer}>
                        <RouteLink
                            className={styles.link}
                            text='Edit'
                            onClick={() => updateCartStepIndex(2)}
                        />
                    </div>
                </div>
            </CheckoutBox>

            <div className={styles.orderSection}>
                <div>
                    <Text size={500} weight='semibold'>
                        Order Items
                    </Text>
                </div>
                <RouteLink
                    className={styles.link}
                    text='Edit Cart Items'
                    onClick={() => updateCartStepIndex(0)}
                />
            </div>
            <div>
                {cart.lineItems.map((x) => (
                    <div key={`${x.lineNumber}-cart-section`}>
                        <LineCard readonly key={`${x.lineNumber}-line-card`} item={x} />
                    </div>
                ))}
            </div>

            <div>
                {cart.accessories.map((accessory) => (
                    <AccessoryCard
                        key={`${accessory.product.baseInfo.name}-card`}
                        readonly
                        accessory={accessory}
                    />
                ))}
            </div>
        </div>
    );
};

export default ReviewOrder;
